import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  BodyWrapper,
  CodeElement,
  CodeImageWrapper,
  Label
} from './styles';

import Menu from '@mui/material/Menu';

const CodeSelectMenu = (props) => {
  const {
    open,
    selected,
    onSelect,
    list,
    setOpen,
    anchorEl
  } = props;

  const intl = useIntl();

  const handleClick = (codeObj) => {
    onSelect(codeObj);
    setOpen(false);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      height="520px"
      onClose={() => setOpen(false)}
      title={<FormattedMessage id="app.editor.Menu.selectBarcodeFormat" defaultMessage="Select barcode format" />}
      slotProps={{
        transition: {
          onExiting: () => {
            if (document.activeElement instanceof HTMLElement) {
              document.activeElement.blur();
            }
          },
        },
        paper: {
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <BodyWrapper>
        {list && list.map(codeObj => {
          const { value, imgSrc, label } = codeObj;
          return (
            <CodeElement
              onClick={() => handleClick(codeObj)}
              key={value}
              $selected={selected.value === value}
            >
              <CodeImageWrapper>
                {codeObj.imgSrc && (
                  <img width="100%" height="100%" src={imgSrc} alt={label} />
                )}
              </CodeImageWrapper>
              <Label>{intl.formatMessage(codeObj.label)}</Label>
            </CodeElement>

          );
        })}
      </BodyWrapper>
    </Menu>
  )
};

export default React.memo(CodeSelectMenu);
